export default {
  navigation: {
    home: "Home",
    comfort: "Confort",
    manage: "Gérer",
    profile: "Profil"
  },
  general: {
    title: "Profil",
    logout: "Se déconnecter",
    app_version: "Version de l'application",
    edit: "Modifier",
    view: "Voir",
    upload: "Télécharger",
    personal_details: {
      title: "Informations personnelles",
      email: "E-mail",
      phone: "Téléphone",
      address: "Adresse",
      not_available: "Non disponible",
      guest_since: "Client depuis :year",
      guest_since_unknown: "Client"
    },
    documents: {
      title: "Passeport et documents",
      passport: "Passeport",
      invoice: "Facture",
      other_documents: "Documents",
      available: "Disponible",
      passport_available: "Disponible",
      not_uploaded: "Non téléchargé",
      info: "Des documents peuvent être requis pour la vérification du check-in"
    },
    preferences: {
      title: "Préférences",
      language: "Langue",
      language_description: "Choisissez votre langue préférée"
    }
  }
};
